/*
 *
 * Surveys actions
 *
 */

import {
  CREATE_SURVEY_WATCHER,
  CREATE_SURVEY_SUCCESS,
  CREATE_SURVEY_FAILED,
  DELETE_SURVEY_WATCHER,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAILED,
  GET_SURVEYS,
  GET_SURVEYS_SUCCESS,
  GET_SURVEYS_FAILED,
  GET_SURVEY_WATCHER,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_FAILED,
  GET_SURVEYS_TEMPLATE_WATCHER,
  GET_SURVEYS_TEMPLATE_SUCCESS,
  GET_SURVEYS_TEMPLATE_FAILED,
  DUPLICATE_SURVEY_WATCHER,
  DUPLICATE_SURVEY_SUCCESS,
  DUPLICATE_SURVEY_FAILED,
  GET_SURVEY_QUALITATIVE_WATCHER,
  GET_SURVEY_QUALITATIVE_SUCCESS,
  GET_SURVEY_QUALITATIVE_FAILED,
  GET_SURVEY_ENPS_WATCHER,
  GET_SURVEY_ENPS_SUCCESS,
  GET_SURVEY_ENPS_FAILED,
  DOWNLOAD_SURVEYS_WATCHER,
  DOWNLOAD_SURVEYS_SUCCESS,
  DOWNLOAD_SURVEYS_FAILED,
  GET_SEGMENTS_WATCHER,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_FAILED,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_FAILED,
  GET_SCOPE_TYPES_WATCHER,
  GET_SCOPE_TYPES_SUCCESS,
  GET_SCOPE_TYPES_FAILED,
  GET_SURVEYS_BY_INDICATORS_WATCHER,
  GET_SURVEYS_BY_INDICATORS_FAILED,
  GET_SURVEYS_BY_INDICATORS_SUCCESS,
} from "./constants"

export function getSurveysByIndicatorsWatcher(payload) {
  return {
    type: GET_SURVEYS_BY_INDICATORS_WATCHER,
    payload,
  }
}
export function getSurveysByIndicatorsSuccess(payload) {
  return {
    type: GET_SURVEYS_BY_INDICATORS_SUCCESS,
    payload,
  }
}
export function getSurveysByIndicatorsFailed(payload) {
  return {
    type: GET_SURVEYS_BY_INDICATORS_FAILED,
    payload,
  }
}
// GET SURVEY ENPS
export function getSurveyEnpsWatcher(payload) {
  return {
    type: GET_SURVEY_ENPS_WATCHER,
    payload,
  }
}

export function getSurveyEnpsSuccess(payload) {
  return {
    type: GET_SURVEY_ENPS_SUCCESS,
    payload,
  }
}

export function getSurveyEnpsFailed(payload) {
  return {
    type: GET_SURVEY_ENPS_FAILED,
    payload,
  }
}

// GET QUALITATIVE
export function getSurveyQualitativeWatcher(payload) {
  return {
    type: GET_SURVEY_QUALITATIVE_WATCHER,
    payload,
  }
}

export function getSurveyQualitativeSuccess(payload) {
  return {
    type: GET_SURVEY_QUALITATIVE_SUCCESS,
    payload,
  }
}

export function getSurveyQualitativeFailed(payload) {
  return {
    type: GET_SURVEY_QUALITATIVE_FAILED,
    payload,
  }
}

// DELETE SURVEY
export function deleteSurveyWatcher(payload) {
  return {
    type: DELETE_SURVEY_WATCHER,
    payload,
  }
}

export function deleteSurveySuccess(payload) {
  return {
    type: DELETE_SURVEY_SUCCESS,
    payload,
  }
}

export function deleteSurveyFailed(payload) {
  return {
    type: DELETE_SURVEY_FAILED,
    payload,
  }
}

// DUPLICATE SURVEY
export function duplicateSurveyWatcher(payload) {
  return {
    type: DUPLICATE_SURVEY_WATCHER,
    payload,
  }
}

export function duplicateSurveySuccess(payload) {
  return {
    type: DUPLICATE_SURVEY_SUCCESS,
    payload,
  }
}

export function duplicateSurveyFailed(payload) {
  return {
    type: DUPLICATE_SURVEY_FAILED,
    payload,
  }
}

// GET SURVEYS TEMPLATE
export function getSurveysTemplateWatcher(payload) {
  return {
    type: GET_SURVEYS_TEMPLATE_WATCHER,
    payload,
  }
}

export function getSurveysTemplateSuccess(payload) {
  return {
    type: GET_SURVEYS_TEMPLATE_SUCCESS,
    payload,
  }
}

export function getSurveysTemplateFailed(payload) {
  return {
    type: GET_SURVEYS_TEMPLATE_FAILED,
    payload,
  }
}

// GET SURVEY
export function getSurveyWatcher(payload) {
  return {
    type: GET_SURVEY_WATCHER,
    payload,
  }
}

export function getSurveySuccess(payload) {
  return {
    type: GET_SURVEY_SUCCESS,
    payload,
  }
}

export function getSurveyFailed(payload) {
  return {
    type: GET_SURVEY_FAILED,
    payload,
  }
}

export const getSurveys = (payload) => {
  return {
    type: GET_SURVEYS,
    payload,
  }
}

export const getSurveysSuccess = (payload) => {
  return {
    type: GET_SURVEYS_SUCCESS,
    payload,
  }
}

export const getSurveysFailed = (payload) => {
  return {
    type: GET_SURVEYS_FAILED,
    payload,
  }
}

export const createSurvey = (payload) => {
  return {
    type: CREATE_SURVEY_WATCHER,
    payload,
  }
}

export const createSurveySuccess = (payload) => {
  return {
    type: CREATE_SURVEY_SUCCESS,
    payload,
  }
}

export const createSurveyFailed = () => {
  return { type: CREATE_SURVEY_FAILED }
}

// DOWNLOAD SURVEY
export function downloadSurveyWatcher(payload) {
  return {
    type: DOWNLOAD_SURVEYS_WATCHER,
    payload,
  }
}

export function downloadSurveySuccess(payload) {
  return {
    type: DOWNLOAD_SURVEYS_SUCCESS,
    payload,
  }
}

export function downloadSurveyFailed(payload) {
  return {
    type: DOWNLOAD_SURVEYS_FAILED,
    payload,
  }
}

export function getSegmentsWatcher(payload) {
  return {
    type: GET_SEGMENTS_WATCHER,
    payload,
  }
}

export function getSegmentsSuccess(payload) {
  return {
    type: GET_SEGMENTS_SUCCESS,
    payload,
  }
}

export function getSegmentsFailed(payload) {
  return {
    type: GET_SEGMENTS_FAILED,
    payload,
  }
}

export function getSurveyTypesWatcher(payload) {
  return {
    type: GET_SURVEY_TYPES_WATCHER,
    payload,
  }
}

export function getSurveyTypesSuccess(payload) {
  return {
    type: GET_SURVEY_TYPES_SUCCESS,
    payload,
  }
}

export function getSurveyTypesFailed(payload) {
  return {
    type: GET_SURVEY_TYPES_FAILED,
    payload,
  }
}

export function getScopeTypesWatcher(payload) {
  return {
    type: GET_SCOPE_TYPES_WATCHER,
    payload,
  }
}

export function getScopeTypesSuccess(payload) {
  return {
    type: GET_SCOPE_TYPES_SUCCESS,
    payload,
  }
}

export function getScopeTypesFailed(payload) {
  return {
    type: GET_SCOPE_TYPES_FAILED,
    payload,
  }
}
